module.exports = __webpack_public_path__ + "static/access_map_ortho-0f35bafb84d7c5c2115edefd0f65d058.svg";